import styled from 'styled-components';

export const ComingSoonBannerContainer = styled.div`
  width: 100vw;
  display: flex;
  text-align: center;
  justify-content: center;
  background-color: #20242e;
  color: #ffffff;
  padding: 10px;
`;
